<template>
  <div v-if="isVisible" class="upgrade-modal">
    <div class="upgrade-content">
      <h1 class="upgrade-heading">Upgrade for more features.</h1>
      <p class="upgrade-body">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacinia odio. Nunc erat diam, fermentum ut ullamcorper a, interdum nec dui. Nulla laoreet turpis felis, a tincidunt tellus pellentesque eget. </p>
      <div class="upgrade-actions">
        <button class="upgrade-btn">Upgrade</button>
        <span class="upgrade-close" @click="toggleModal">close</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpgradeModal',
  props: {
    isVisible: false,
    theme: String
  },
  methods: {
    toggleModal: function () {
      this.isVisible = !this.isVisible
    }
  }
}
</script>

<style lang="scss" scoped>
  .upgrade-modal {
    display: flex;
    justify-content: center;
    align-content: center;
    background-color: rgba(240,240,240,0.7);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;
  }

  .upgrade-content {
    background-color: #fff;
    padding: 50px 50px;
    display: flex;
    border: 1px solid #eee;
    margin-bottom: auto;
    margin-top: auto;
    position: relative;
    flex-direction: column;
    max-width: 600px;
  }

  .upgrade-actions {
    display: flex;
    align-items: flex-end;
    margin-top: 20px;
  }

  .upgrade-close {
    cursor: pointer;
    font-size: 14px;
    font-family: 'Roboto';
    color: #999;
    margin-left: 10px;
  }

  .upgrade-heading {
    font-size: 22px;
    margin-bottom: 20px;
  }
  
  .upgrade-body {
    font-size: 14px;
  }
  
  .upgrade-btn {
    background: green;
    border: none;
    border-radius: 3px;
    color: #ffffff;
    display: inline-block;
    font-family: "Roboto Medium", Helvetica, Arial, sans-serif;
    font-size: 12px;
    height: 45px;
    line-height: 45px;
    overflow: visible;
    padding: 0 25px;
    text-align: center;
    transition: background-color 0.25s;
    white-space: nowrap;
    width: auto;
  }
</style>


// WEBPACK FOOTER //
// src/js/components/UpgradeModal.vue